import { gross, isPro, lei, resale, shortName } from "@/lib/pricing";
import { Thumb, useProductSheet } from "./PriceList";

export default function ResaleList({ data, track }) {
  const [show, sheet] = useProductSheet(data, track);
  return (
    <section className="pub-section" data-testid="section-sugestie">
      <header className="pub-sec-head">
        <span className="pub-eyebrow">Pentru clienta salonului</span>
        <h2>Sugestie preț vânzare</h2>
        <p>Produsele mici se revând la raft: prețul salonului cu TVA + {data.markup}% adaos. Toate prețurile includ TVA. Formatele mari sunt pentru tratamente în salon.</p>
      </header>
      <ul className="pl-list">
        {data.products.map((p) => (
          <li key={p.id} className="pl-row pl-row--tap" role="button" tabIndex={0} onClick={() => show(p)} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), show(p))} data-testid={`resale-row-${p.id}`}>
            <Thumb p={p} />
            <div className="pl-info">
              <b>{shortName(p.name)}</b>
              <span className="pl-size">{p.size}</span>
              <span className="pl-idx">Cumperi cu {lei(gross(p.price, data.vat))}</span>
            </div>
            {isPro(data, p.id) ? (
              <div className="pl-price pl-price--resale pl-price--pro">
                <small>Uz profesional</small>
                <b>{data.treatments} trat.</b>
                <span>pe set, în salon</span>
              </div>
            ) : (
              <div className="pl-price pl-price--resale">
                <small>Vinzi cu</small>
                <b>{lei(resale(p.price, data.markup, data.vat))}</b>
                <span>TVA inclus</span>
              </div>
            )}
          </li>
        ))}
      </ul>
      {sheet}
    </section>
  );
}
